import React, { useState } from "react";
// import './add.css';
import {
    Button,
    Form,
    Col,
    Row,
    Container,
    Modal,
    Accordion,
    Card,
    Image
  } from "react-bootstrap";
// import {useForm, Controller} from "react-hook-form";
import {useForm} from "react-hook-form";
import axios from 'axios';
import Cropper from 'react-easy-crop'
import getCroppedImg from '../../../images-media/crop-image';
// import { useHistory } from "react-router-dom";
// import { Storage } from '../../../../../firebase/index';
import SyncLoader from "react-spinners/SyncLoader";
import Select from 'react-select';
import {language_list} from '../../../../lists/language-list';
import {speciality_list} from '../../../../lists/speciality-list';
// import {services_list} from '../../../../lists/services-list';
import GenericModal from '../../../../generic/modal';
import _ from 'lodash';
import { ErrorMessage } from '@hookform/error-message';
import PhoneInput from 'react-phone-input-2';
import countryList from 'react-select-country-list'
import { uuid } from 'uuidv4';
import ReactGA from 'react-ga';

export default function UpdateDentist(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const biography_maxLength = 1000;
    const backup_picture_url ="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"
    let clinicData = props.clinicData;
    let dentist = props.dentist;

    const [loading, setLoading] = useState(false);
    // const [selectedTreatments, setSelectedTreatments] = useState(dentist.services || []);
    const [selectedLanguages, setSelectedLanguages] = useState(dentist.languages_spoken || []);
    const [show, setShow] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [success, setSuccess] = useState(Boolean);
    const [phone, setPhone] = useState('');
    const [nationality, setNationality] = useState(dentist.nationality || '');

    const [imageSrc, setImageSrc] = useState(null);
    const [showCropModal, setShowCropModal] = useState(false);
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null)

    const startCroping = async (image) => {
      let imageDataUrl = await readFile(image);
      setImageSrc(imageDataUrl);
      setShowCropModal(true);
    }

    function readFile(file) {
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.addEventListener('load', () => resolve(reader.result), false)
        reader.readAsDataURL(file)
      })
    }

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }
      
  const cropImage = async () => {
    const cropImg = await getCroppedImg(imageSrc, croppedAreaPixels);
    setCroppedImage(cropImg);
    handleClose();
  }

    // const [dentist, setDentist] = useState({});

    const handleClose = () => {
      setShowDeleteModal(false);
      setShow(false);
    }
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
          biography:            (dentist.biography || null),
          email:                (dentist.email || null),
          gender:               (dentist.gender || null),
          languages_spoken:     (dentist.languages_spoken || null),
          first_name:           (dentist.first_name || null),
          last_name:            (dentist.last_name || null),
          phone:                (dentist.mobile_number || null),
          nationality:          (dentist.nationality || null),
          education:            (dentist.education || null),
          license:              (dentist.license || null),
          work_title:           (dentist.work_title || null),
          years:                (dentist.years_experience || null),
        }
    });

    const findWithAttr = (array, attr, value) => {
      for(var i = 0; i < array.length; i += 1) {
          if(array[i][attr] === value) {
              return i;
          }
      }
      return -1;
  }
 
  const removeDentist = (dentist) => {
    setShow(false);
    setLoading(true);
    const token = localStorage.getItem('token');
    let axiosConfig = {
      headers: {
          Authorization: token
      }
    };
    axios.post(`https://uae-dentist-backend.herokuapp.com/staff/remove`, {_id : dentist._id}, axiosConfig)
    .then(function (response) {
      let newDentistArray = clinicData.dentists.filter(function( dent ) {
          return dent._id !== dentist._id;
      });
      props.clinicData.dentists = newDentistArray;
      setLoading(false);
      console.log(response);
    })
    .catch(function (error) {
      console.log(error);
    });
  };
  
    const handleChange = async (e) => {
      console.log(e);
      setSelectedLanguages(Array.isArray(e) ? e.map(x => x.value) : []);
    }

    const uploadImage = async (image) => { 
      return new Promise(resolve => { 
        const uploadTask = Storage.ref(`dentists/${uuid()}`).put(image);
        uploadTask.on('state_changed', function(snapshot){
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload is ' + progress + '% done');
        }, function(error) {
          // Handle unsuccessful uploads
        }, function() {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            console.log('File available at', downloadURL);
            resolve(downloadURL);
          });
        });
      })
    }
  

    const onSubmit = async (data) => {
      setLoading(true);
      if(data.picture && data.picture.length > 0 ){
        let url = await uploadImage(croppedImage);
        data.picture_url = url;
        delete data.picture; 
      }
      const token = localStorage.getItem('token');
      let axiosConfig = {
        headers: {
            Authorization: token
        }
      };
      data.phone = phone;
      data.nationality = nationality.label;
      data._id = dentist._id;
      data.full_name = data.first_name.trim() + ' ' + data.last_name.trim();
      // data.services = selectedTreatments;
      data.languages = selectedLanguages;
        delete data.picture; 
        axios.post(`https://uae-dentist-backend.herokuapp.com/staff/update`, data, axiosConfig)
        .then( (response) => {
          console.log(response);
          let index = findWithAttr(clinicData.dentists, "_id", data._id )
          _.extend(props.clinicData.dentists[index], data);
          console.log(props.clinicData.dentists[index])
          setSuccess(true);
          setShow(true);
          setLoading(false);
        })
        .catch(function (error) {
          setSuccess(false);
          setShow(true);
          setLoading(false);
          console.log(error);
        });
    }

    return (
    <Container className="mt-2 rounded">
      <Row sm={1} md={1} lg={1}>
      <Col className=''>
        { show && <GenericModal setShow={setShow} show={show} success={success}/>}
      </Col>
    </Row>
    <Row sm={2} md={2} lg={2}>
    <Col sm={12} md={3} lg={3}  className="">
      <div id="message" className='rounded shadow p-3 mb-2 text-center'>
        <Image  className='border' src={`${dentist.picture_url || backup_picture_url}`} roundedCircle fluid/>
        <h4 className='mt-4'>{dentist.full_name}</h4>
        <h6>{dentist.work_title}</h6>
      </div>
    </Col>
    <Col sm={12} md={9} lg={9} id="form" className="rounded">
    
    <Form onSubmit={handleSubmit(onSubmit)}>
        <Accordion defaultActiveKey="0">
      <Card>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="0">
            Background
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body>
          <Form.Group >
            <Form.Label>Full Name </Form.Label>
            <Form.Control required placeholder="Full Name" name="name" ref={register ({required:true})}/>
          </Form.Group>

        <Form.Group >
            <Form.Label>Gender </Form.Label>
            <Form.Control as="select" name="gender" ref={register ({required:true})} custom >
            <option>Male</option>
            <option>Female</option>
            </Form.Control>
        </Form.Group>

        <Form.Group controlId="nationality">
        <Form.Label>Nationality </Form.Label>
            <Select
            options={countryList().getData()}
            value={nationality}
            onChange={setNationality}
          />
        </Form.Group>

        <Form.Group controlId="languages">
        <Form.Label>Languages Spoken </Form.Label>
            <Select 
            value={language_list.filter(obj => selectedLanguages.includes(obj.value))}
            isMulti
            isClearable
            onChange={handleChange}
            options = {language_list} 
            className="basic-multi-select"
            classNamePrefix="select"
            />
        </Form.Group>

        <Form.Group controlId="picture">
          <Form.File onChange={(event) => startCroping(event.target.files[0], 'round') } name="picture" ref={register} accept=".jpg,.gif,.png" label="Upload a picture" />
        </Form.Group>
        <Form.Group controlId="description">
            <Form.Label>Biography (Max {biography_maxLength} characters)</Form.Label>
            <Form.Control required as="textarea" rows="3" name="biography" ref={register({maxLength: biography_maxLength})}  />
            <ErrorMessage errors={errors} name="biography" message={`The biography needs to be shorter than ${biography_maxLength} charachters.`} />
        </Form.Group> 
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      <Card>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="1">
            Experience & Education
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="1">
          <Card.Body>

          <Form.Group >
            <Form.Label>Education </Form.Label>
            <Form.Control required as="textarea" rows="3" placeholder="Dental College of Dental Sciences" name="education" ref={register ({required:true})}/>
        </Form.Group>

        <Form.Group >
            <Form.Label>Work Title </Form.Label>
            <Form.Control as="select" name="work_title" ref={register ({required:true})} custom >
              {speciality_list.map((speciality, idx) => (
                          <option key={idx}>{speciality.value}</option>
              ))}
            </Form.Control>
        </Form.Group>

        <Form.Group >
            <Form.Label>License Number</Form.Label>
            <Form.Control pattern="[0-9]{8}-[0-9]{3}" type="tel" required placeholder="12345678-910" name="license" ref={register ({required:true})}/>
        </Form.Group>

        <Form.Group >
            <Form.Label>Work Experience </Form.Label>
            <Form.Control required as="textarea" rows="3" placeholder="Write down your work experience" name="experience" ref={register ({required:true})}/>
        </Form.Group>


        <Form.Group>
            <Form.Label>Years Experience </Form.Label>
            <Form.Control required name="years" type="number" ref={register ({required:true})} placeholder="How many years have you worked as a dentist?" />
        </Form.Group>

        </Card.Body>
        </Accordion.Collapse>
      </Card>

      <Card>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="2">
            Contact Information
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="2">
          <Card.Body>

          <Form.Group controlId="phone">
        <Form.Label>Phone Number</Form.Label>
          <PhoneInput 
            className='w-100'
            // localization={ae}
            country={'ae'}
            placeholder="Please provide your phone number" 
            value={phone}
            onChange={input => setPhone( input )}
          />
        </Form.Group>

        <Form.Group >
            <Form.Label>Email </Form.Label>
            <Form.Control required placeholder="dentist@clinic.com" name="email" ref={register ({required:true})}/>
        </Form.Group>

        <Form.Group >
            <Form.Label>LinkedIn </Form.Label>
            <Form.Control required placeholder="http://linkedin.com/in/linkedinyourname." name="linkedin" ref={register}/>
        </Form.Group>

        </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>

        <Button variant="primary" type="submit">
            Update Dentist
        </Button>
        <Button variant="danger" onClick={() => setShowDeleteModal(true)}>
            Remove
        </Button> 
        <div className='mt-5'>
          <SyncLoader
            size={15}
            margin={2}
            color={"#123abc"}
            loading={loading}
          />
        </div>
    </Form>
    
    </Col>
    </Row>
    <Modal size="lg" show={showCropModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Crop Image</Modal.Title>
            </Modal.Header>
              <Modal.Body className="scale">
              <Cropper
                cropShape={'round'}
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                aspect={1}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                showGrid={false}
                // onCropComplete={() =>console.log('stopped')}
                onZoomChange={setZoom}
              />
              </Modal.Body>
              <Form>
              <Form.Group className='text-center' controlId="formBasicRange">
                <Form.Label>Zoom</Form.Label>
                <Form.Control 
                
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                onChange={(e) => setZoom(e.target.value)}
                type="range" 
                custom 
                />
              </Form.Group>
              <Modal.Footer>
              <Button variant="primary" onClick={()=>cropImage()}>
                Crop
              </Button>
              <Button variant="danger" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
            </Form>
          </Modal>

    <Modal show={showDeleteModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Are you sure that you want to remove {dentist.full_name}?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>This action is irreversible and can create a lot of harm. Proceed with caution!</p>
        <Button variant="danger" onClick={() => removeDentist(dentist)}>
            Remove
        </Button>
        <Button variant="info float-right" onClick={handleClose}>
            Cancel
        </Button>

      </Modal.Body>
    </Modal>
    
    </Container>
    )
}